export default function (initialDataInteractor, workspaceId) {
  initialDataInteractor.data.workspaces.forEach(function (workspace, index) {
    if (workspace.id == workspaceId) {
      initialDataInteractor.data.workspaces.splice(index, 1);
    }
  })
}